import React from 'react'
import './Banner.css'
export default function Banner() {
  return (
    <div className='banner'>
      <img src="https://dog55574plkkx.cloudfront.net/images/flipkart-big-billion-days-offer.jpg" alt="" />
    </div>
  )
}
